export default __webpack_public_path__ + "static/media/invoiceOilChange.abacd924.png";